// extracted by mini-css-extract-plugin
export default {"Container":"Service_Container__2txHI"};